module.exports = __webpack_public_path__ + "static/media/map_region.f7e9ec40.svg";